import { render, staticRenderFns } from "./article_detail.vue?vue&type=template&id=23fcc43e&scoped=true"
import script from "./article_detail.vue?vue&type=script&lang=js"
export * from "./article_detail.vue?vue&type=script&lang=js"
import style0 from "./article_detail.vue?vue&type=style&index=0&id=23fcc43e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fcc43e",
  null
  
)

export default component.exports